export default {
  data () {
    return {
      countries: require('../../static/countries.json')
    }
  },
  methods: {
    getCountryName (isoCode) {
      if (isoCode === 'GL') return 'Global'
      const country = this.countries.find(country => country.country_iso_code === isoCode)
      return country ? country.location_name : isoCode
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/countryMixin.js